import React, { useState } from "react";
import {
  Title,
  GoBack,
  TextArea,
  MyMessage,
  MyActionButton,
} from "../../component/Component";
import { useStaticContext } from "../../../../context/static/StaticContext";
import { getOnePrivacy } from "../../../../middlewares/sysNavigation/SysNavigation";

const Edit = () => {
  const { updatePrivacy } = useStaticContext();
  const privacy = getOnePrivacy();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const privacy_id = privacy?.privacy_id;
  const [description, setDescription] = useState(privacy?.description);

  const privacyRoutes = "/privacy";

  const responses = (error, message) => {
    setError(error);
    setSuccess(!error);
    setLoading(false);
    setErrorMessage(message);
  };

  const updateOnePrivacyHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const { status, message } = await updatePrivacy({
      id: privacy_id,
      data: { description },
    });
    if (status === 200) responses(false, message);
    else responses(true, message);
  };

  return (
    <div className="p-4 h-full overflow-y-auto rounded-b-xl bg-gray-50">
      <div className="mx-auto w-full max-w-5xl">
        <div className="mb-3 flex items-center justify-between">
          <GoBack props={{ route: privacyRoutes }} />
        </div>

        <form onSubmit={updateOnePrivacyHandler}>
          <div className="mb-3">
            <MyMessage
              error={error}
              message={message}
              success={success}
              onExpired={() => {
                setError(false);
                setSuccess(false);
              }}
              onClick={() => {
                setError(false);
                setSuccess(false);
                setErrorMessage("");
              }}
            />
          </div>

          <div className="mb-4 rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
            <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <Title props={{ title: "Privacy Policy" }} />
                <p className="mt-1 text-[11px] text-gray-500">
                  Keep the language clear and aligned with your data practices.
                </p>
              </div>
              <span className="inline-flex items-center gap-2 rounded-full bg-gray-50 px-3 py-1 text-[11px] font-medium ring-1 ring-gray-200">
                <span
                  className={[
                    "h-1.5 w-1.5 rounded-full",
                    loading ? "bg-amber-500" : success ? "bg-emerald-500" : "bg-gray-300",
                  ].join(" ")}
                />
                {loading ? "Saving…" : success ? "Saved" : "Editing"}
              </span>
            </div>
          </div>

          <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
            <div className="p-4">
              <div className="rounded-lg border bg-gray-50/60 p-3 hover:bg-gray-50">
                <TextArea
                  props={{
                    id: "description",
                    title: "",
                    type: "text",
                    value: description ? description : "",
                    rows: 10,
                    onChange: (e) => {
                      setDescription(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
                <p className="mt-2 text-[11px] text-gray-500">
                  Tip: Use short paragraphs and plain language.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-4 flex items-center justify-end">
            <MyActionButton
              title="Save Changes"
              loading={loading}
              onClick={() => {
                setError(false);
                setSuccess(false);
                setErrorMessage(null);
              }}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default Edit;
